/* eslint-disable max-lines-per-function */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useEffect } from 'react'
import { Grid, Container, Typography, Box } from '@mui/material'
import { useLang } from '~/hooks/useLang'
import { getDetailsOccurrences } from '~/features/Dispatch/services'
import { useHookstate } from '@hookstate/core'
import dayjs from 'dayjs'
import { truncate } from '~/features/Dispatch/utils/stringsManipulations'

interface IDetailsOccurrences {
  readonly id: number
  readonly code: string
  readonly dispatched_at: string
  readonly closed_at: string
  readonly type: string
  readonly subtype?: string
  readonly occurrence: {
    readonly featured: boolean
    readonly city: string
    readonly district?: string
  }
}

const tableStyles = {
  container: {
    width: '100%',
    border: '1px solid #000',
    borderCollapse: 'collapse' as const,
    fontSize: '12px',
    '@media print': {
      fontSize: '10px',
      width: '100%',
      tableLayout: 'fixed' as const,
    },
  },
  headerCell: {
    border: '1px solid #000',
    padding: '8px 4px',
    fontWeight: 'bold',
    textAlign: 'start' as const,
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    '@media print': {
      padding: '4px 2px',
      fontSize: '10px',
      backgroundColor: 'transparent',
    },
  },
  dataCell: {
    border: '1px solid #000',
    padding: '8px 4px',
    textAlign: 'left' as const,
    color: '#000000DE',
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    wordWrap: 'break-word' as const,
    '@media print': {
      padding: '3px 2px',
      fontSize: '0.875rem',
    },
  },
}

export default function DetailsOccurrences({ id }) {
  const { translate } = useLang()
  const detailsOccurrences = useHookstate<
    readonly IDetailsOccurrences[] | null
  >(null)

  useEffect(() => {
    getDetailsOccurrences(id).then((response) => {
      detailsOccurrences.set(response)
    })
  }, [])

  if (!detailsOccurrences.get()?.length) {
    return (
      <Container fixed={false}>
        <Grid container justifyContent="center">
          <Grid item xs={12} sx={{ textAlign: 'center', marginTop: 2 }}>
            <Typography variant="body1">
              <b>{translate('NO INFORMATION REGISTERED')}</b>
            </Typography>
          </Grid>
        </Grid>
      </Container>
    )
  }

  return (
    <Container fixed={false} sx={{ marginTop: 0, paddingTop: 0 }}>  {/* Remover margem top */}
      <Box component="table" sx={{ ...tableStyles.container, marginTop: 0 }}>  {/* Garantir sem margem na tabela */}
        <Box component="thead">
          <Box component="tr">
            <Box
              component="th"
              sx={{ ...tableStyles.headerCell, width: '15%' }}
            >
              CÓDIGO
            </Box>
            <Box
              component="th"
              sx={{ ...tableStyles.headerCell, width: '10%' }}
            >
              REGISTRO
            </Box>
            <Box
              component="th"
              sx={{ ...tableStyles.headerCell, width: '10%' }}
            >
              FECHAMENTO
            </Box>
            <Box
              component="th"
              sx={{ ...tableStyles.headerCell, width: '25%' }}
            >
              TIPO
            </Box>
            <Box
              component="th"
              sx={{ ...tableStyles.headerCell, width: '15%' }}
            >
              SUBTIPO
            </Box>
            <Box
              component="th"
              sx={{ ...tableStyles.headerCell, width: '10%' }}
            >
              CIDADE
            </Box>
            <Box
              component="th"
              sx={{ ...tableStyles.headerCell, width: '10%' }}
            >
              BAIRRO
            </Box>
            <Box component="th" sx={{ ...tableStyles.headerCell, width: '5%' }}>
              DES
            </Box>
          </Box>
        </Box>
        <Box component="tbody">
          {detailsOccurrences.get()?.map((row) => (
            <Box component="tr" key={row.id}>
              <Box component="td" sx={tableStyles.dataCell}>
                {row.code}
              </Box>
              <Box component="td" sx={tableStyles.dataCell}>
                {dayjs(row.dispatched_at).format('DD/MM/YYYY HH:mm')}
              </Box>
              <Box component="td" sx={tableStyles.dataCell}>
                {row.closed_at
                  ? dayjs(row.closed_at).format('DD/MM/YYYY HH:mm')
                  : 'NI'}
              </Box>
              <Box component="td" sx={tableStyles.dataCell}>
                {truncate(row.type, 50)}
              </Box>
              <Box component="td" sx={tableStyles.dataCell}>
                {row?.subtype ? row.subtype : 'NI'}
              </Box>
              <Box component="td" sx={tableStyles.dataCell}>
                {row.occurrence.city ?? 'NI'}
              </Box>
              <Box component="td" sx={tableStyles.dataCell}>
                {row.occurrence.district ?? 'NI'}
              </Box>
              <Box component="td" sx={tableStyles.dataCell}>
                {row.occurrence.featured ? translate('Yes') : translate('No')}
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Container>
  )
}
